export const withPlural = (
  totalQuantity: number,
  singular: string,
  plural: string,
) => {
  if (totalQuantity == 1) return `${totalQuantity} ${singular}`;
  else return `${totalQuantity} ${plural}`;
};
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";